import { render } from "./TruncateTooltip.vue?vue&type=template&id=3dc1bd7f&scoped=true"
import script from "./TruncateTooltip.vue?vue&type=script&lang=js"
export * from "./TruncateTooltip.vue?vue&type=script&lang=js"

import "./TruncateTooltip.vue?vue&type=style&index=0&id=3dc1bd7f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc1bd7f"]])

export default __exports__